module.exports = __webpack_public_path__ + "static/iso_12.76889bc8.png";